import { analyzeData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    analyzeData
  }
};
